import {RoomInfo} from './component';
import {inject, IReactComponent} from 'mobx-react';

import './styles.scss';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.inviteStore?.inviteFlowManager?.roomInfoController,
    translate: stores.inviteStore?.localizationService?.translate?.bind(stores.inviteStore.localizationService)
});

const RoomInfoComponent = inject(mapStoresToProps)(RoomInfo) as IReactComponent;

export default RoomInfoComponent;
